var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login-bg"}),_c('div',{staticClass:"login-page d-flex"},[_c('input',{staticClass:"d-none",attrs:{"type":"checkbox","name":"","id":"login"}}),_c('LoginLogo'),_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }